import React from "react";
import PropTypes from "prop-types";
import WmsButton from "../react/components/WmsButton/WmsButton";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";
import WmsDropdown from "../react/components/WmsDropdown/WmsDropdown";
import * as GlobalService from "../react/global_services";
import "./adjustCustomerCharges.scss";
import WmsRadio from "../react/components/WmsRadio/WmsRadio";
import { FormState } from "./adjust-customer-charges-const";

interface Props {
    wmsSelector: string;
    sharedFilterObject: any;
    setSharedFilterObject: (filterObject: any) => void;
    windowId: any;
    onClearSearch: () => void;
    onHandleNext: () => void;
    onHandleReturn: () => void;
    step: number;
    selectedRowCount: number;
    formData: FormState;
    setFacilityOptions: (facilityOptions: any[]) => void;
    optionsFacility: any[];
    onChangeChargeType: () => void;
    isCreateBillingManagerChargeLoading: boolean;
}

declare var window: any;

const AdjustCustomerChargesSearch: React.FC<Props> = (incomingProps: Props): any => {
    const {
        wmsSelector = "",
        sharedFilterObject = {},
        windowId = "",
        onClearSearch = (): void => {},
        onHandleNext = (): void => {},
        onHandleReturn = (): void => {},
        setSharedFilterObject = (filterObject: any): void => {},
        selectedRowCount = 0,
        isCreateBillingManagerChargeLoading = false,
    } = incomingProps;
    const props = {
        ...incomingProps,
        wmsSelector,
        sharedFilterObject,
        windowId,
        onClearSearch,
        onHandleNext,
        onHandleReturn,
        setSharedFilterObject,
        selectedRowCount,
        isCreateBillingManagerChargeLoading,
    };

    const CustomLabels = GlobalService.getCustomLabels();
    const optionsCustomer = GlobalService.getCustomerList(true);

    const handleFilterChange = (event: any) => {
        let name = event.target.name;
        let value = event.target.value;
        let selectedCustomer;
        let customerName;
        let FacilityID;

        customerName = props.sharedFilterObject.CustomerName;
        if (event.target.name === "CustomerID") {
            value = parseInt(value);
            handleCustomerChange(parseInt(event.target.value));

            // Find the selected customer to get the name
            selectedCustomer = optionsCustomer.find((cus: any) => cus.id === value);
            customerName = selectedCustomer ? selectedCustomer.name : "";
            FacilityID = null;
        }
        if (event.target.name === "FacilityID") {
            value = parseInt(value) ? parseInt(value) : null;
        }
        props.setSharedFilterObject((previousState) => ({
            ...previousState,
            [name]: value,
            CustomerName: customerName, // Store the customer name as well
            ...(FacilityID !== undefined && { FacilityID: FacilityID }),
        }));
    };
    const handleCustomerChange = (CustomerID: any) => {
        var selectedCustomer = optionsCustomer.find((cus: any) => cus.id === CustomerID);
        if (selectedCustomer) {
            var customerFacilityIds = selectedCustomer.facilities;
            let allFacilities = GlobalService.getFacilityList(true);
            allFacilities = allFacilities.filter((f: any) => customerFacilityIds.includes(f.id) || f.id === 0);
            props.setFacilityOptions(allFacilities);
        } else {
            props.setFacilityOptions([]);
        }
    };

    const handleChargeTypeChange = (type: string) => () => {
        props.onChangeChargeType();
        props.setSharedFilterObject((previousState) => ({
            ...previousState,
            ChargeType: type,
        }));
    };

    return (
        <div className="adjust-customer-charges-add-charge-wrapper">
            <div className="adjust-customer-charges-add-charge">
                {props.step === 1 && (
                    <div>
                        <WmsDropdown
                            id="attach_file_assembly_search_CustomerId"
                            name="CustomerID"
                            label={CustomLabels.Label_Customer}
                            wmsSelector={props.wmsSelector + "SelectCustomer"}
                            value={props.sharedFilterObject.CustomerID}
                            onChangeFunc={handleFilterChange}
                            options={optionsCustomer}
                            valueField="id"
                            textField="name"
                            required
                            extraWrapperClass="customer-dropdown"
                        />
                        <WmsDropdown
                            id="attach_file_assembly_search_warehouse"
                            name="FacilityID"
                            label={CustomLabels.Label_Warehouse}
                            wmsSelector={props.wmsSelector + "SelectWarehouse"}
                            value={props.sharedFilterObject.FacilityID}
                            onChangeFunc={handleFilterChange}
                            options={props.optionsFacility}
                            valueField="id"
                            textField="name"
                            extraWrapperClass="customer-dropdown"
                            disabled={!props.sharedFilterObject.CustomerID}
                            required
                        />
                    </div>
                )}
                {props.step !== 1 && (
                    <div className="customer-section">
                        <div className="customer-info">
                            <p>{window.translate("Label_Customer_Text")}</p>
                            <p>{props.sharedFilterObject.CustomerName || "Not selected"}</p>
                        </div>
                        <div className="customer-info">
                            <p>{window.translate("Window_Title_Label_Warehouse")}</p>
                            <p>
                                {GlobalService.getFacilityList(true).find(
                                    (fid) => fid.id === props.sharedFilterObject.FacilityID
                                )?.name || "Not selected"}
                            </p>
                        </div>
                    </div>
                )}
                <div className="actions-buttons">
                    <WmsButton
                        label={window.translate("Label_Cancel")}
                        wmsSelector={window.wmsSelector + "CancelButton"}
                        onClickFunc={props.onClearSearch}
                        buttonType="orange"
                        disabled={!props.sharedFilterObject.CustomerID}
                    />
                    {props.step !== 1 && (
                        <WmsButton
                            label={window.translate("Label_Return")}
                            wmsSelector={window.wmsSelector + "ReturnButton"}
                            onClickFunc={props.onHandleReturn}
                            buttonType="outlined"
                            icon="fa-angle-left"
                        />
                    )}
                    <WmsButton
                        label={
                            props.step >= 3 ||
                            (props.sharedFilterObject.ChargeType === "isManualCharge" && props.step === 2)
                                ? window.translate("Label_service_submit")
                                : window.translate("Label_Next")
                        }
                        wmsSelector={props.wmsSelector + "NextButton"}
                        onClickFunc={props.onHandleNext}
                        icon="fa-angle-right"
                        iconPosition={props.isCreateBillingManagerChargeLoading ? "before" : "after"}
                        disabled={
                            !props.sharedFilterObject.CustomerID ||
                            !props.sharedFilterObject.FacilityID ||
                            !props.sharedFilterObject.ChargeType ||
                            (props.sharedFilterObject.ChargeType === "isPredefinedRate" &&
                                ((props.step === 2 && props.selectedRowCount !== 1) ||
                                    (props.step === 3 && Number(props.formData.quantity) === 0))) ||
                            (props.sharedFilterObject.ChargeType === "isManualCharge" &&
                                props.step === 2 &&
                                (props.formData.category === "" ||
                                    Number(props.formData.chargeAmount) === 0 ||
                                    Number(props.formData.quantity) === 0))
                        }
                        loading={props.isCreateBillingManagerChargeLoading}
                    />
                </div>
            </div>
            <div className="warehouse-form-boxes">
                {props.sharedFilterObject.CustomerID && props.sharedFilterObject.FacilityID && props.step === 1 ? (
                    <WmsCollapse
                        id="Label_Add_A_Charge"
                        headerLabel={window.translate("Label_Add_A_Charge")}
                        showCollapseText={false}
                        showCollapseIcon={false}
                    >
                        <div className="charge-selection-container">
                            <p className="add-charge-description">
                                {window.translate("Label_Add_A_Charge_Description")}
                            </p>
                            <div className="charge-selection-radio-container">
                                <WmsRadio
                                    id="IsPredefinedRate"
                                    name="IsPredefinedRate"
                                    label={window.translate("Label_Select_Predefined_Rate")}
                                    wmsSelector={props.wmsSelector + "IsPredefinedRate"}
                                    onChangeFunc={handleChargeTypeChange("isPredefinedRate")}
                                    checked={props.sharedFilterObject.ChargeType === "isPredefinedRate"}
                                />
                                <WmsRadio
                                    id="IsManualCharge"
                                    name="IsManualCharge"
                                    label={window.translate("Label_Add_A_Manual_Charge")}
                                    wmsSelector={props.wmsSelector + "IsManualCharge"}
                                    onChangeFunc={handleChargeTypeChange("isManualCharge")}
                                    checked={props.sharedFilterObject.ChargeType === "isManualCharge"}
                                />
                            </div>
                        </div>
                    </WmsCollapse>
                ) : null}
            </div>
        </div>
    );
};
AdjustCustomerChargesSearch.propTypes = {
    wmsSelector: PropTypes.string.isRequired,
    sharedFilterObject: PropTypes.any.isRequired,
    windowId: PropTypes.any.isRequired,
    onClearSearch: PropTypes.func.isRequired,
    onHandleNext: PropTypes.func.isRequired,
    onHandleReturn: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    setSharedFilterObject: PropTypes.func.isRequired,
};

export default React.memo(AdjustCustomerChargesSearch);
